import api from './api';

const saleService = {
  /**
   * Crear venta
   */
  async create(saleData) {
    try {
      const response = await api.post('/sales', saleData);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al registrar venta'
      };
    }
  },

  /**
   * Obtener todas las ventas
   */
  async getAll(params = {}) {
    try {
      const response = await api.get('/sales', { params });
      return {
        success: true,
        data: response.data.data,
        pagination: response.data.pagination
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener ventas'
      };
    }
  },

  /**
   * Obtener venta por ID
   */
  async getById(id) {
    try {
      const response = await api.get(`/sales/${id}`);
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener venta'
      };
    }
  },

  /**
   * Cancelar venta
   */
  async cancel(id) {
    try {
      const response = await api.post(`/sales/${id}/cancel`);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al cancelar venta'
      };
    }
  },

  /**
   * Obtener resumen de ventas (dashboard)
   */
  async getSummary(params = {}) {
    try {
      const response = await api.get('/sales/summary', { params });
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener resumen'
      };
    }
  }
};

export default saleService;


